import type { FrontendModule } from '@/lib/types'
import { DeadlinesPage } from './pages/DeadlinesPage'
import { UpcomingDeadlinesWidget } from './widgets/UpcomingDeadlinesWidget'

/**
 * Moduł `deadlines` — „Terminy procesowe" (moduł OPCJONALNY, env `MODULES_ENABLED`).
 *
 * Trasa `/terminy` musi być identyczna z `NavItem.route` w manifeście backendu
 * (`app/modules/deadlines/module.py`); nawigacja pochodzi wyłącznie z `/api/me/context`.
 */
export const deadlinesModule: FrontendModule = {
  key: 'deadlines',
  routes: [{ path: 'terminy', element: <DeadlinesPage /> }],
  dashboardWidgets: [
    { id: 'deadlines.upcoming', column: 'side', order: 10, component: UpcomingDeadlinesWidget },
  ],
}

export default deadlinesModule
